/**
 * @deprecated Built-in action migrated to Actions API. Keeping around for
 * backwards compatibility.
 */
export const ACTION_TYPE = 'actionType';
/**
 * @deprecated Built-in action migrated to Actions API. Keeping around for
 * backwards compatibility.
 */
export const SUBSCRIPTION_ID = 'subscriptionId';
/**
 * @deprecated Built-in action migrated to Actions API. Keeping around for
 * backwards compatibility.
 */
export const OPT_STATE = 'optState';
/**
 * @deprecated Built-in action migrated to Actions API. Keeping around for
 * backwards compatibility.
 */
export const LEGAL_BASIS = 'legalBasis';
/**
 * @deprecated Built-in action migrated to Actions API. Keeping around for
 * backwards compatibility.
 */
export const LEGAL_BASIS_EXPLANATION = 'legalBasisExplanation';